import { Component, inject, input, model, output } from '@angular/core';
import { ModalComponent } from '../../../../components/modal/modal.component';
import { InputComponent } from '../../../../components/input/input.component';
import { ButtonDirective } from '../../../../components/button/button.directive';
import { DictionaryService } from '../../../../services/dictionary.service';
import { SnackbarService } from '../../../../services/snackbar.service';

@Component({
  selector: 'app-rejection-modal',
  imports: [ModalComponent, InputComponent, ButtonDirective],
  templateUrl: './rejection-modal.component.html',
  styleUrl: './rejection-modal.component.scss',
})
export class RejectionModalComponent {
  protected readonly dictionaryService = inject(DictionaryService);
  private readonly snackbar = inject(SnackbarService);

  // Inputs
  isOpen = model<boolean>(false);
  isProcessing = input<boolean>(false);

  // Outputs
  onSubmit = output<string>();
  onClose = output<void>();

  // Internal state
  rejectionMessage = model<string>('');

  handleClose(): void {
    this.isOpen.set(false);
    this.rejectionMessage.set('');
    this.onClose.emit();
  }

  handleSubmit(): void {
    const message = this.rejectionMessage().trim();

    if (!message) {
      this.snackbar.showError(
        this.dictionaryService.get('PleaseEnterRejectionMessage') ||
          'Please enter a rejection message',
      );
      return;
    }

    this.onSubmit.emit(message);
  }
}
